import { LocalityModel } from '@/types/LocalityModel';

/**
 * Séparateur de variantes : dans Payload, un éditeur peut écrire
 * "Texte A|||Texte B|||Texte C" dans n'importe quel champ passant par
 * `replaceTags`. Une variante est choisie par ville, de façon déterministe
 * (même ville = toujours la même variante, pour rester stable en cache et
 * ne pas donner à Google l'impression qu'une page change de contenu à
 * chaque crawl).
 */
const VARIANT_DELIMITER = '|||';

function pickVariant(string: string, seed: number): string {
  if (!string.includes(VARIANT_DELIMITER)) return string;

  const variants = string.split(VARIANT_DELIMITER).map((variant) => variant.trim());

  return variants[seed % variants.length]!;
}

export function replaceTagsInScripts(
  string: string,
  slug: string,
  currentLocalite: LocalityModel,
) {
  return string
    .replaceAll('*##url-locality##*', slug)
    .replaceAll('*##locality##*', currentLocalite?.displayName ?? '')
    .replaceAll(
      '*##country##*',
      getPrepositionForCountry(currentLocalite?.country ?? ''),
    )
    .replaceAll(
      '*##province##*',
      getPreposition(currentLocalite?.province ?? ''),
    );
}

// `.replaceAll` — chaque tag peut apparaitre plusieurs fois dans un meme champ
// (plusieurs phrases d'un bloc CTA, par exemple) ; `.replace` ne remplacait que
// la premiere occurrence et laissait les suivantes affichees telles quelles
// (`*##locality##*` litteral dans le rendu).
//replace-tag-service
export function replaceTags(string: string, currentLocalite: LocalityModel) {
  if (!string) return string;

  return pickVariant(string, currentLocalite.id)
    .replaceAll('*##locality##*', currentLocalite.displayName)
    .replaceAll(
      '*##country##*',
      getPrepositionForCountry(currentLocalite.country),
    )
    .replaceAll(
      '*##province##*',
      currentLocalite.province
        ? getPreposition(currentLocalite.province)
        : getPreposition(currentLocalite.commune),
    )
    .replaceAll('*##postalCode##*', currentLocalite.postalCodes?.[0] ?? '')
    .replaceAll('*##commune##*', currentLocalite.commune ?? '');
}

//replace-tag-service
function getPreposition(province: string) {
  switch (province) {
    case 'Liège':
    case 'Anvers':
    case 'Namur':
    case 'Bruxelles-Capitale':
      return `à ${province}`;
    case 'Flandre Occidentale':
    case 'Flandre Orientale':
      return `en ${province}`;
    default:
      return `au ${province}`;
  }
}

function getPrepositionForCountry(country: string) {
  switch (country) {
    case 'Belgique':
      return `en ${country}`;
    default:
      return `au ${country}`;
  }
}
